import React from "react";

export interface GridCardProps {
  title: string;
  headers: string[];
  data: string[][];
  loading?: boolean;
  onRowClick?: (index: number) => void;
  selectedRowIndex?: number | null;
}

const cardBase =
  "bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-md p-4 overflow-x-auto";

const GridCard: React.FC<GridCardProps> = ({
  title,
  headers,
  data,
  loading = false,
  onRowClick,
  selectedRowIndex,
}) => {
  if (loading) {
    return (
      <div className={cardBase}>
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">
          {title}
        </h3>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Loading Information...
        </p>
      </div>
    );
  }

  return (
    <div className={cardBase}>
      <h3 className="font-semibold mb-2 text-gray-900 dark:text-gray-100">
        {title}
      </h3>

      {data && data.length > 0 ? (
        <table className="min-w-full border-collapse table-fixed text-sm">
          {/* Header */}
          <thead className="bg-gray-100 dark:bg-gray-800">
            <tr>
              {headers.map((h, i) => (
                <th
                  key={i}
                  className="text-left border border-gray-300 dark:border-gray-700 p-2 font-medium text-gray-800 dark:text-gray-200"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          {/* Body */}
          <tbody>
            {data.map((row, rowIndex) => {
              const isSelected = rowIndex === selectedRowIndex;

              return (
                <tr
                  key={rowIndex}
                  onClick={() => onRowClick?.(rowIndex)}
                  className={`
                    cursor-pointer transition-colors
                    ${
                      isSelected
                        ? "bg-blue-100 dark:bg-blue-900/40"
                        : "hover:bg-gray-50 dark:hover:bg-gray-800"
                    }
                  `}
                >
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className="border border-gray-300 dark:border-gray-700 p-2 break-words text-gray-800 dark:text-gray-200"
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p className="italic text-gray-500 dark:text-gray-400 mt-2">
          No data available.
        </p>
      )}
    </div>
  );
};

export default GridCard;